import { Component, Input, OnInit } from '@angular/core';
import { StrategyInstrumentsFormService } from 'src/app/services/strategy-instruments-form.service';
import { defaultInstrumentRiskLevels } from '../constants';
import { ChartConfiguration } from 'chart.js';
import { ChartPoint, InstrumentDetailFullOut } from 'src/app/services/rest-api/rest-api';
import { AvailablePerformanceYears } from '../listable-instruments/listable-instruments.component';

@Component({
  selector: 'libero-available-instrument-toggler',
  templateUrl: './available-instrument-toggler.component.html',
  styleUrls: ['./available-instrument-toggler.component.scss'],
  standalone: false
})
export class AvailableInstrumentTogglerComponent implements OnInit {
  @Input() public availableInstrument!: InstrumentDetailFullOut;
  @Input() public hideAddButtons = false;
  @Input() public selectedPerformance!: AvailablePerformanceYears;

  public defaultInstrumentRiskLevels = defaultInstrumentRiskLevels;

  public toggled = false;

  public showForbiddenMessage = false;

  public get yieldChartData(): ChartConfiguration['data'] {
    return {
      datasets: [
          {
            data: this.chartDataset,
            borderColor: this.negativeYield ? '#e52713' : '#3FA535',
            pointRadius: 0,
            pointHoverRadius: 0,
            borderWidth: 2,
          }
        ],
        // backend should always provide 30 values
        labels: Array.from(Array(30).keys())
      }
  }

  private availableCharts: ChartPoint[][] = [];

  private get chartDataset(): ChartPoint[] {
    return this.availableCharts[this.selectedPerformance ?? 1];
  }

  public get negativeYield(): boolean {
    let selectedYield = 0;
    switch (this.selectedPerformance) {
      case 1:
        selectedYield = this.availableInstrument.yield1Y;
        break;
      case 3:
        selectedYield = this.availableInstrument.yield3Y;
        break;
      case 5:
        selectedYield = this.availableInstrument.yield5Y;
        break;
    }

    return selectedYield < 0;
  }

  public hiddenAxisChartOptions: ChartConfiguration['options'] = {
    animation: false,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        enabled: false,
      },
    },
    scales: {
      xAxis: {
        grid: {
          display: false,
          drawBorder: false,
        },
        ticks: {
          display: false,
        },
      },
      yAxis: {
        grid: {
          display: false,
          drawBorder: false,
        },
        ticks: {
          display: false,
        },
      },
    },
  };

  public constructor(
    public instrumentsService: StrategyInstrumentsFormService,
  ) { }

  public ngOnInit(): void {
    this.generateChartData();
  }

  private generateChartData(): void {
    if (!this.availableInstrument.prices1) return;
    this.availableCharts[1] = this.availableInstrument.prices1.map(
      (price, index) => {
        return {
          x: index,
          y: price ?? NaN,
        }
      }
    );
    if (!this.availableInstrument.prices3) return;
    this.availableCharts[3] = this.availableInstrument.prices3.map(
      (price, index) => {
        return {
          x: index,
          y: price ?? NaN,
        }
      }
    );
    if (!this.availableInstrument.prices5) return;
    this.availableCharts[5] = this.availableInstrument.prices5.map(
      (price, index) => {
        return {
          x: index,
          y: price ?? NaN,
        }
      }
    );
  }

  public toggle(): void {
    this.toggled = !this.toggled;
  }

  public get instrumentNotVisibleToCollaborator(): boolean {
    if (!this.availableInstrument)
      return false;
    return !this.availableInstrument.visibleToCollaborator;
  }

  public get instrumentAlreadyAdded(): boolean {
    return !!this.instrumentsService.getSelectedInstrumentById(this.availableInstrument.instrumentId);
  }

  public removeInstrument(): void {
    this.instrumentsService.removeSelectedInstrumentById(this.availableInstrument.instrumentId);
  }

  public addInstrument(): void {
    this.instrumentsService.addInstrumentControl(this.availableInstrument);
  }
}
